import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IQuestionnaireQuestion } from 'src/app/interfaces/Questionnaire/IQuestionnaire';

// Titles separate the instruction with "||" or "‖".
const FAC_TITLE_SEPARATOR = /\|\||‖/;

// One question (838): the chosen level, (5) to (0), is the result, so there
// is no score field. Level (0) is a real answer, not a missing one.
@Component({
  selector: 'app-fac-questions',
  templateUrl: './fac-questions.component.html',
  styleUrl: './fac-questions.component.css',
  standalone: false,
})
export class FacQuestionsComponent {
  @Input() elements: IQuestionnaireQuestion[] = [];
  // The page title holds the test's heading and instruction.
  @Input() pageTitle = '';
  @Input() formGroup!: FormGroup;
  @Input() readonlyMode = false;

  onRadioClick(controlName: string, value: any): void {
    if (this.readonlyMode) return;
    const control = this.formGroup.get(controlName);
    if (!control) return;

    if (control.value === value) {
      control.setValue(null);
    }
  }

  getQuestionTitle(title?: string): string {
    return title?.split(FAC_TITLE_SEPARATOR)[0]?.trim() ?? '';
  }

  getQuestionInstruction(title?: string): string {
    return title?.split(FAC_TITLE_SEPARATOR)[1]?.trim() ?? '';
  }
}
